import { graphql } from 'relay-runtime';

export const NotifyFairUseLimitReachedMutation = graphql`
    mutation notifyFairUseLimitReachedMutation($serviceName: String!) {
        notifyFairUseLimitReached(serviceName: $serviceName)
    }
`;
